import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { slide as Menu } from 'react-burger-menu'


const Header = () => {
    const data = useStaticQuery(graphql`
    {
      storyblokEntry(name: {eq: "navigation"}) {
        content
        name
      }
    }
  `)

    let story = JSON.parse(data.storyblokEntry.content)

    let menu_content = story.global[1].nav_links.map(nav_link => (
        <li className="">
            <Link to={`/${ nav_link.link_url.cached_url }`} className="hover:underline uppercase tracking-widest md:text-sm lg:text-xs xl:text-sm">
                { nav_link.link_name }
            </Link>
        </li>
    ))

    return (
        <div className="sticky top-0 z-50 mx-auto items-center md:py-4 md:px-18 md:flex md:justify-between md:px-8 xl:py-4 header-class bg-cream shadow-sm">
            <div className="block md:hidden">
                <Menu>
                    {menu_content}
                </Menu>
            </div>
            
            <div class="flex justify-end p-4 md:p-0">
                <Link to={`/${ story.global[0].logo_url.cached_url }`}>
                    <img src="https://a.storyblok.com/f/120530/2083x421/12458f28ff/hirst-yarns-logo.png" width="280" className="sm:justify-end"/>
                </Link>
            </div>

            <nav>
                <ul className="hidden md:block md:flex md:flex-row md:gap-12 xl:gap-20">
                    {menu_content}
                </ul>
    
            </nav>
        </div>
    )
}

export default Header

